import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { faArrowRight, faUserCircle, faXmark } from "@fortawesome/pro-light-svg-icons";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { faBarsFilter } from "@fortawesome/pro-solid-svg-icons";
import { useAuth } from "@qure/qure-auth";
import classNames from "classnames";
import { capitalize, get } from "lodash";
import { useRouter } from "next/router";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { applyFilterOrder } from "../../utils/filterOrder";
import { PatientsContext } from "../Patients/PatientsContext";
import Store from "../../utils/Store";
import constants from "../../utils/constants";
import { requestWorklistFilterChange } from "../../utils/worklistFilterNavigation";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import AwesomeIcon from "../AwesomeIcon";
import useGetReport from "../ReportTemplate/services/useGetReport";
import { formatFiltersObj } from "../SearchFilters/utils";
import Toast from "../Toast";
import ReportingInfoModal from "./ReportingInfoModal";
import Modal from "../common/Modal";
import Button from "../common/Button";
import reorderFilters from "./services/reorderFilters";
import useDeleteFilter from "../SearchFilters/services/useDeleteFilter";
import { QuickFilterCard } from "./QuickFilterCard";
import { LCQuickFilterCard } from "./LCQuickFilterCard";
import { ReactSortable } from "react-sortablejs";
import { t } from "i18next";
var ShowMoreButton = function ShowMoreButton(_ref) {
  var onClick = _ref.onClick,
    highlighted = _ref.highlighted,
    count = _ref.count;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: classNames("h-full flex items-center gap-2 px-[16px] rounded-[8px] border whitespace-nowrap shrink-0 w-[150px]", highlighted ? "bg-[#008280] border-[#008280]" : "bg-[rgba(0,130,128,0.12)] border-[#00d0cd]")
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("text-[16px] font-medium", highlighted ? "text-white" : "text-[#008280]")
  }, t("label.show_more") || "Show more", count != null && count > 0 ? " (".concat(count, ")") : ""), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronRight,
    className: classNames("w-5 h-5", highlighted ? "text-white" : "text-[#008280]")
  }));
};
var ShowLessButton = function ShowLessButton(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: "h-full flex items-center gap-2 px-[16px] rounded-[8px] bg-[rgba(0,130,128,0.12)] border border-[#00d0cd] whitespace-nowrap shrink-0 w-[150px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[16px] font-medium text-[#008280]"
  }, t("label.show_less")), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    className: "text-[#008280] w-5 h-5"
  }));
};
var QuickAccessFilters = function QuickAccessFilters(props) {
  var patientsCount = props.patientsCount,
    isCountLoading = props.isCountLoading,
    patients = props.patients,
    setFilters = props.setFilters,
    filters = props.filters,
    setLastId = props.setLastId,
    setSavedFilterData = props.setSavedFilterData,
    setPatientsData = props.setPatientsData,
    savedFilters = props.savedFilters;
  var router = useRouter();
  var _useState = useState(false),
    isModalOpen = _useState[0],
    setIsModalOpen = _useState[1];
  var _useState2 = useState(true),
    trySwiftReporting = _useState2[0],
    setTrySwiftReporting = _useState2[1];
  var mainContainerRef = useRef(null);
  var _useAuth = useAuth(),
    refetchProfile = _useAuth.refetchProfile;
  var _useContext = useContext(PatientsContext),
    filterOrder = _useContext.filterOrder,
    setFilterOrder = _useContext.setFilterOrder;
  var deleteFilterMutation = useDeleteFilter();
  var isLC = process.env.NEXT_PUBLIC_IS_LC === "true";

  // ── LC show-more / drag-reorder state ──────────────────────────────────────

  var _useState3 = useState(false),
    showMore = _useState3[0],
    setShowMore = _useState3[1];
  var _useState4 = useState(function () {
      return applyFilterOrder(savedFilters, filterOrder);
    }),
    orderedFilters = _useState4[0],
    setOrderedFilters = _useState4[1];

  // Sync orderedFilters when savedFilters or filterOrder changes.
  useEffect(function () {
    if (!isLC) return;
    setOrderedFilters(function (prev) {
      var prevIds = prev.map(function (f) {
        return f.id;
      });
      var next = applyFilterOrder(savedFilters, filterOrder);
      var nextIds = next.map(function (f) {
        return f.id;
      });
      var sameSet = prevIds.length === nextIds.length && prevIds.every(function (id) {
        return nextIds.includes(id);
      });
      if (sameSet) {
        var sameOrder = prevIds.every(function (id, i) {
          return id === nextIds[i];
        });
        if (sameOrder) return prev.map(function (f) {
          var _savedFilters$find;
          return (_savedFilters$find = savedFilters.find(function (sf) {
            return sf.id === f.id;
          })) !== null && _savedFilters$find !== void 0 ? _savedFilters$find : f;
        });
        return next.map(function (f) {
          var _savedFilters$find2;
          return (_savedFilters$find2 = savedFilters.find(function (sf) {
            return sf.id === f.id;
          })) !== null && _savedFilters$find2 !== void 0 ? _savedFilters$find2 : f;
        });
      }
      if (next.length <= firstRowCountRef.current + 1) setShowMore(false);
      return next;
    });
  }, [savedFilters, isLC, filterOrder]);

  // When a new filter is pinned in SearchFilters, update the server order to include it.
  var prevSavedFilterIdsRef = useRef([]);
  useEffect(function () {
    if (!isLC) return;
    var prevIds = prevSavedFilterIdsRef.current;
    var currentIds = savedFilters.map(function (f) {
      return f.id;
    });
    var addedIds = prevIds.length > 0 ? currentIds.filter(function (id) {
      return !prevIds.includes(id);
    }) : [];
    prevSavedFilterIdsRef.current = currentIds;
    if (!addedIds.length) return;
    // Prepend new filter(s) to the front of the order.
    var newOrder = [].concat(_toConsumableArray(addedIds), _toConsumableArray(filterOrder.filter(function (id) {
      return !addedIds.includes(id);
    })));
    var orderedIds = applyFilterOrder(savedFilters, newOrder).map(function (f) {
      return f.id;
    });
    reorderFilters({
      ordered_ids: orderedIds
    });
    setFilterOrder(orderedIds);
  }, [savedFilters, isLC, filterOrder]);

  // Measure the available row-1 container width and derive how many cards fit.
  var lcContainerRef = useRef(null);
  var _useState5 = useState(0),
    row1Width = _useState5[0],
    setRow1Width = _useState5[1];
  useEffect(function () {
    var el = lcContainerRef.current;
    if (!el) return;
    var observer = new ResizeObserver(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        entry = _ref4[0];
      return setRow1Width(entry.contentRect.width);
    });
    observer.observe(el);
    setRow1Width(el.getBoundingClientRect().width);
    setShowMore(localStorage.getItem(constants.PERSISTED.lcSavedFiltersShowMore) === "true");
    return function () {
      return observer.disconnect();
    };
  }, []);
  useEffect(function () {
    localStorage.setItem(constants.PERSISTED.lcSavedFiltersShowMore, showMore.toString());
  }, [showMore]);

  // card fixed width = 150px, gap-2 = 8px, Show More button ≈ 140px (incl. gap before it)
  var CARD_MIN = 150;
  var GAP = 8;
  var VIEW_ALL_W = 140;
  var firstRowCount = useMemo(function () {
    var total = orderedFilters.length;
    var available = row1Width;
    if (available === 0 || total === 0) return Math.min(total, 5);
    // How many cards fit without a View All button?
    var capacityFull = Math.floor((available + GAP) / (CARD_MIN + GAP));
    if (total <= capacityFull) return total;
    // Reserve space for the View All button.
    var capacityWithBtn = Math.max(1, Math.floor((available - VIEW_ALL_W + GAP) / (CARD_MIN + GAP)));
    // Ensure at least 1 card is left for row 2.
    return Math.min(capacityWithBtn, total - 1);
  }, [row1Width, orderedFilters.length]);

  // Only show "Show more" if more than 1 card is hidden — if exactly 1 is hidden, just show it.
  var effectiveFirstRowCount = orderedFilters.length === firstRowCount + 1 ? orderedFilters.length : firstRowCount;
  var hasOverflow = orderedFilters.length > effectiveFirstRowCount;
  var hiddenCount = hasOverflow ? orderedFilters.length - effectiveFirstRowCount : 0;
  var visibleItems = showMore ? orderedFilters : orderedFilters.slice(0, effectiveFirstRowCount);

  // When the viewport widens enough to fit every card (no overflow), collapse
  // back so the stale "expanded" state isn't persisted in localStorage.
  useEffect(function () {
    if (!hasOverflow && showMore) setShowMore(false);
  }, [hasOverflow, showMore]);

  // True when a currently applied filter is hidden behind "Show more".
  var hasSelectedHidden = !showMore && orderedFilters.slice(effectiveFirstRowCount).some(function (item) {
    return (filters === null || filters === void 0 ? void 0 : filters.id) === item.id || Array.isArray(filters === null || filters === void 0 ? void 0 : filters.selectedFilters) && filters.selectedFilters.some(function (f) {
      return f.id === item.id;
    });
  });

  // Sentinel item appended to the sortable list so react-sortablejs can map the
  // ShowLess/ShowMore button back to a list entry. It is stripped out in handleSetList.
  var BUTTON_SENTINEL_ID = -1;
  var buttonSentinel = {
    id: BUTTON_SENTINEL_ID
  };
  // Show the toggle button only when collapsing actually hides cards (overflow).
  // Without the hasOverflow guard, "Show less" would keep showing after the
  // viewport widens enough to fit every card on one row.
  var sortableList = [].concat(_toConsumableArray(visibleItems), _toConsumableArray(hasOverflow ? [buttonSentinel] : []));

  // Always-current refs so event callbacks read fresh state without stale closures.
  var orderedFiltersRef = useRef(orderedFilters);
  orderedFiltersRef.current = orderedFilters;
  var savedFiltersRef = useRef(savedFilters);
  savedFiltersRef.current = savedFilters;
  var firstRowCountRef = useRef(firstRowCount);
  firstRowCountRef.current = firstRowCount;

  // Stores the latest merged order so handleDragEnd can persist it.
  var pendingListRef = useRef([]);

  // Build the full ordered_ids payload for the reorder API.
  var buildOrderedIds = function buildOrderedIds(displayed) {
    var displayedIds = displayed.map(function (f) {
      return f.id;
    });
    var remainder = savedFiltersRef.current.filter(function (f) {
      return !displayedIds.includes(f.id);
    }).map(function (f) {
      return f.id;
    });
    return [].concat(_toConsumableArray(displayedIds), _toConsumableArray(remainder));
  };
  var effectiveFirstRowCountRef = useRef(effectiveFirstRowCount);
  effectiveFirstRowCountRef.current = effectiveFirstRowCount;
  var handleSetList = function handleSetList(newList) {
    var realItems = newList.filter(function (f) {
      return f.id !== BUTTON_SENTINEL_ID;
    });
    var merged = showMore ? realItems : [].concat(_toConsumableArray(realItems), _toConsumableArray(orderedFiltersRef.current.slice(effectiveFirstRowCountRef.current)));
    pendingListRef.current = merged;
    setOrderedFilters(merged);
  };

  // Fires exactly once per drop — persists the order set by handleSetList.
  var handleDragEnd = function handleDragEnd() {
    var ordered_ids = buildOrderedIds(pendingListRef.current);
    reorderFilters({
      ordered_ids: ordered_ids
    });
    setFilterOrder(ordered_ids);
  };
  var _useState6 = useState(false),
    isDeleteModalOpen = _useState6[0],
    setIsDeleteModalOpen = _useState6[1];
  var _useState7 = useState(null),
    filterToDelete = _useState7[0],
    setFilterToDelete = _useState7[1];
  var handleDeleteFilter = function handleDeleteFilter(item) {
    setFilterToDelete(item);
    setIsDeleteModalOpen(true);
  };
  var handleConfirmDelete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var item, isSingleFilterApplied, isInMultiSelect, remaining, label, updatedFilters, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (filterToDelete) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            item = filterToDelete;
            setIsDeleteModalOpen(false);
            setFilterToDelete(null);
            _context.p = 2;
            _context.n = 3;
            return deleteFilterMutation.mutateAsync(item.id);
          case 3:
            void refetchProfile();
            isSingleFilterApplied = (filters === null || filters === void 0 ? void 0 : filters.id) === item.id;
            isInMultiSelect = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.selectedFilters) && filters.selectedFilters.some(function (f) {
              return f.id === item.id;
            });
            if (isSingleFilterApplied) {
              handleResetFilters();
            } else if (isInMultiSelect) {
              remaining = filters.selectedFilters.filter(function (f) {
                return f.id !== item.id;
              });
              if (remaining.length === 0) {
                handleResetFilters();
              } else {
                label = remaining.map(function (f) {
                  var _savedFiltersRef$curr;
                  return ((_savedFiltersRef$curr = savedFiltersRef.current.find(function (sf) {
                    return sf.id === f.id;
                  })) === null || _savedFiltersRef$curr === void 0 ? void 0 : _savedFiltersRef$curr.name) || "";
                }).filter(function (n) {
                  return n.length > 0;
                }).join(", ");
                updatedFilters = _objectSpread(_objectSpread({}, filters), {}, {
                  selectedFilters: remaining,
                  label: label
                });
                requestWorklistFilterChange(function () {
                  setFilters(updatedFilters);
                  setLastId("");
                  localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(updatedFilters));
                });
              }
            }
            Toast.success(t("filter.toast.removed_successfully"));
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            Toast.error(t("message.error_deleting_filter") || "Failed to delete filter");
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function handleConfirmDelete() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleCancelDelete = function handleCancelDelete() {
    setIsDeleteModalOpen(false);
    setFilterToDelete(null);
  };

  // Toggle an LC filter card and immediately apply the full updated selection.
  var handleLCCardApply = function handleLCCardApply(item, itemIsSelected) {
    // Build the current selection from applied filters state.
    var currentSelection = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.selectedFilters) ? filters.selectedFilters : filters !== null && filters !== void 0 && filters.id && filters !== null && filters !== void 0 && filters.isFilterApplied ? [{
      id: filters.id,
      values: filters.filter
    }] : [];

    // Toggle the clicked item in/out of the selection.
    var newSelection = itemIsSelected ? currentSelection.filter(function (f) {
      return f.id !== item.id;
    }) : [].concat(_toConsumableArray(currentSelection), [{
      id: item.id,
      values: item.filter
    }]);
    if (newSelection.length === 0) {
      var _document$getElementB;
      (_document$getElementB = document.getElementById("worklist-container")) === null || _document$getElementB === void 0 || _document$getElementB.scrollTo(0, 0);
      setLastId("");
      handleResetFilters();
      return;
    }
    requestWorklistFilterChange(function () {
      var _document$getElementB2;
      (_document$getElementB2 = document.getElementById("worklist-container")) === null || _document$getElementB2 === void 0 || _document$getElementB2.scrollTo(0, 0);
      setLastId("");
      var filterNames = newSelection.map(function (f) {
        var _savedFilters$find3;
        return ((_savedFilters$find3 = savedFilters.find(function (sf) {
          return sf.id === f.id;
        })) === null || _savedFilters$find3 === void 0 ? void 0 : _savedFilters$find3.name) || "";
      }).filter(function (n) {
        return n.length > 0;
      }).join(", ");
      var appliedFilters = _objectSpread(_objectSpread({}, filters), {}, {
        isFilterApplied: true,
        selectedFilters: newSelection,
        label: filterNames,
        multiSelectLogic: "AND",
        data: _objectSpread(_objectSpread({}, get(filters, ["data"], {})), {}, {
          search: get(filters, ["data", "search"], "")
        })
      });
      setFilters(appliedFilters);
      setPatientsData(null);
      localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(appliedFilters));
      trackEvent(MIXPANEL_EVENTS.QUICK_ACCESS_FILTER_APPLIED, {
        isSavedFilter: true,
        savedFilterName: filterNames,
        isMultiSelect: newSelection.length > 1,
        filterCount: newSelection.length
      });
    });
  };
  // ───────────────────────────────────────────────────────────────────────────

  var handleSingleTagchange = function handleSingleTagchange(item) {
    requestWorklistFilterChange(function () {
      var name = item.name,
        filter = item.filter,
        is_default = item.is_default,
        id = item.id;
      if (name === constants.DEFAULT_FILTER_NAME.negativeCXR && is_default) {
        setTrySwiftReporting(true);
      }
      var formattedFilters = formatFiltersObj(filter);
      var appliedFilter = {
        isFilterApplied: true,
        label: name,
        data: formattedFilters,
        id: id
      };
      setFilters(appliedFilter);
      setSavedFilterData(filter);
      localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(appliedFilter));
      localStorage.setItem(constants.PERSISTED.savedFilterData, JSON.stringify(filter));
      trackEvent(MIXPANEL_EVENTS.QUICK_ACCESS_FILTER_APPLIED, _objectSpread(_objectSpread({}, formattedFilters), {}, {
        isSavedFilter: !!name,
        savedFilterName: name,
        filterId: id
      }));
    });
  };
  var _useGetReport = useGetReport(true),
    reportTemplateData = _useGetReport.data;
  var templateData = get(reportTemplateData, ["all_templates"]);
  var handleSwiftReporting = function handleSwiftReporting() {
    Store.update(function (s) {
      s.swiftModeEnabled = true;
    }), localStorage.setItem(constants.PERSISTED.isSwiftReportModeEnabled, "true");
    router.replace("/viewer/quredicom/".concat(get(patients, [0, "patient_uid"])));
  };
  var handleSwiftButton = function handleSwiftButton() {
    trackEvent(MIXPANEL_EVENTS.SWIFT_REPORTING_OPENED);
    var swiftTemplate = templateData === null || templateData === void 0 ? void 0 : templateData.filter(function (item) {
      return item.is_pinned && item.name === constants.DEFAULT_FILTER_NAME.negativeCXR;
    });
    if ((swiftTemplate === null || swiftTemplate === void 0 ? void 0 : swiftTemplate.length) !== 0) {
      handleSwiftReporting();
    } else {
      setIsModalOpen(true);
    }
  };
  var handleCloseModal = function handleCloseModal() {
    setIsModalOpen(false);
    trackEvent(MIXPANEL_EVENTS.REPORTING_INFO_MODAL_CLOSED);
  };
  var handleResetFilters = function handleResetFilters() {
    setFilters({
      isFilterApplied: false,
      data: null,
      label: "",
      selectedFilters: undefined
    });
    setSavedFilterData(null);
    localStorage.removeItem(constants.PERSISTED.filterObj);
    localStorage.removeItem(constants.PERSISTED.savedFilterData);
  };
  var handleFilterCardClick = function handleFilterCardClick(isSelected, item) {
    var _document$getElementB3;
    (_document$getElementB3 = document.getElementById("worklist-container")) === null || _document$getElementB3 === void 0 || _document$getElementB3.scrollTo(0, 0);
    setLastId("");
    if (isSelected) {
      handleResetFilters();
    } else {
      handleSingleTagchange(item);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-5 sm:py-4 flex flex-col sm:flex-row justify-between  dark:bg-gray-800 items-baseline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex px-5 shrink-0"
  }, filters.label === constants.DEFAULT_FILTER_NAME.negativeCXR ? /*#__PURE__*/React.createElement("div", {
    className: classNames("p-4 bg-teal-600 hover:bg-teal-700 cursor-pointer h-full rounded-lg border flex items-center space-x-4 border-teal-400", {
      invisible: !trySwiftReporting || patientsCount === 0
    }),
    onClick: handleSwiftButton
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-teal-800 p-2 rounded-lg"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 18.4062H14V19V20H17.8333C19.0284 20 20 19.0471 20 17.875V8.12988C20 7.56543 19.7732 7.02422 19.3669 6.62578L16.2997 3.6209C15.8935 3.22246 15.3451 3 14.7695 3H9.16667C7.97161 3 7 3.95293 7 5.125V8.07422V11H7.5C8 11 8 11 8.625 11V5.125C8.625 4.83281 8.86875 4.59375 9.16667 4.59375H14.5833V7.25C14.5833 7.8377 15.0674 8.3125 15.6667 8.3125H18.375V17.875C18.375 18.1672 18.1312 18.4062 17.8333 18.4062Z",
    className: "fill-gray-200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81934 19.8662C7.24512 20.292 7.94043 20.292 8.36621 19.8662L13.3662 14.8662C13.792 14.4404 13.792 13.7451 13.3662 13.3193C12.9404 12.8936 12.2451 12.8936 11.8193 13.3193L7.59277 17.5459L5.86621 15.8193C5.44043 15.3936 4.74512 15.3936 4.31934 15.8193C3.89355 16.2451 3.89355 16.9404 4.31934 17.3662L6.81934 19.8662Z",
    className: "fill-teal-300"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-white text-md w-full"
  }, t("report_these_filtered", {
    patientsCount: patientsCount
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex text-teal-200 items-center space-x-3"
  }, /*#__PURE__*/React.createElement("button", {
    className: "text-base"
  }, t("try_swift_reporting")), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowRight,
    className: "w-5 stroke-[3]"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      setTrySwiftReporting(false);
      trackEvent(MIXPANEL_EVENTS.SWIFT_REPORTING_DISMISSED);
    },
    className: "flex justify-start group w-fit pl-6 mb-6",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "text-white group-hover:bg-gray-300 p-2 rounded-md"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classNames("text-gray-600 dark:text-gray-600", {
      "!invisible": filters === null || filters === void 0 ? void 0 : filters.isFilterApplied
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUserCircle,
    className: "w-6 h-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-2 text-2xl font-medium"
  }, isCountLoading ? /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-2",
    role: "status"
  }) : patientsCount)), /*#__PURE__*/React.createElement("p", {
    className: "flex mt-1 text-[14px]"
  }, t("patients_key")))), /*#__PURE__*/React.createElement("div", {
    ref: lcContainerRef,
    className: classNames("flex w-full sm:w-fit sm:justify-end pb-5 sm:py-3 px-5 sm:!w-[65%]")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleResetFilters,
    className: "sm:hidden flex-grow"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("text-gray-400 relative space-y-2 pr-4 pt-3", {
      "bg-teal-900 p-3 w-24 rounded-lg !text-gray-100 pr-0": filters === null || filters === void 0 ? void 0 : filters.isFilterApplied
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm",
    className: classNames("bg-teal-400 absolute rounded-full p-2 w-[10px] h-[10px] top-0 -right-3", {
      hidden: !(filters !== null && filters !== void 0 && filters.isFilterApplied)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: filters !== null && filters !== void 0 && filters.isFilterApplied ? faBarsFilter : faUserCircle
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-2 text-lg font-medium"
  }, isCountLoading ? /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-2",
    role: "status"
  }) : patientsCount)), /*#__PURE__*/React.createElement("p", {
    className: "text-md text-start pl-4"
  }, " ", filters !== null && filters !== void 0 && filters.isFilterApplied ? capitalize(t("filter.filtered_patients")) : t("patients_key")))), isLC ?
  /*#__PURE__*/
  /* ── LC layout: single sortable list, show-more/show-less ── */
  React.createElement("div", {
    className: classNames("border-l border-gray-400 pl-4 sm:pl-0 sm:border-none min-w-0 ml-auto", {
      hidden: (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) === 0
    })
  }, /*#__PURE__*/React.createElement(ReactSortable, {
    list: sortableList,
    setList: handleSetList,
    handle: ".drag-handle",
    filter: ".no-sort",
    ghostClass: "lc-drag-ghost",
    animation: 150,
    onEnd: handleDragEnd,
    tag: "div",
    className: "flex flex-wrap gap-2"
  }, sortableList.map(function (item) {
    if (item.id === BUTTON_SENTINEL_ID) {
      return /*#__PURE__*/React.createElement("div", {
        key: "btn-sentinel",
        className: "no-sort"
      }, showMore ? /*#__PURE__*/React.createElement(ShowLessButton, {
        onClick: function onClick() {
          return setShowMore(false);
        }
      }) : /*#__PURE__*/React.createElement(ShowMoreButton, {
        onClick: function onClick() {
          return setShowMore(true);
        },
        highlighted: hasSelectedHidden,
        count: hiddenCount
      }));
    }
    var itemIsSelected = Boolean((filters === null || filters === void 0 ? void 0 : filters.id) === item.id || Array.isArray(filters === null || filters === void 0 ? void 0 : filters.selectedFilters) && filters.selectedFilters.some(function (f) {
      return f.id === item.id;
    }));
    return /*#__PURE__*/React.createElement(LCQuickFilterCard, {
      key: item.id,
      item: item,
      isSelected: itemIsSelected,
      onFilterClick: function onFilterClick() {
        return handleLCCardApply(item, itemIsSelected);
      },
      onDelete: function onDelete() {
        return handleDeleteFilter(item);
      }
    });
  }))) :
  /*#__PURE__*/
  /* ── Non-LC layout: unchanged horizontal scroll ── */
  React.createElement("div", {
    ref: mainContainerRef,
    className: classNames("border-l border-gray-400 pl-4 sm:pl-0 sm:border-none flex items-center space-x-4 min-w-0 flex-nowrap ml-auto relative overflow-x-auto pr-4", {
      hidden: (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) === 0
    })
  }, savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.map(function (item, index) {
    return /*#__PURE__*/React.createElement(QuickFilterCard, {
      key: index,
      item: item,
      filters: filters,
      onFilterClick: handleFilterCardClick
    });
  }))), /*#__PURE__*/React.createElement(Modal, {
    show: isDeleteModalOpen,
    onClose: handleCancelDelete,
    title: t("label.deleting_saved_filters") || "Deleting saved filter",
    className: "!w-auto min-w-[400px]",
    closeOnClickAway: true,
    zIndex: "z-[1000]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-6"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-900 dark:text-gray-100"
  }, t("label.delete_filter_confirm") || "This saved filter will be permanently deleted.")), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end p-4 border-t border-gray-200 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "w-auto",
    onClick: handleCancelDelete
  }, t("button.cancel") || "Cancel"), /*#__PURE__*/React.createElement(Button, {
    isDanger: true,
    className: "w-auto",
    onClick: handleConfirmDelete
  }, t("label.delete_filter") || "Delete filter")))), /*#__PURE__*/React.createElement(ReportingInfoModal, {
    isVisible: isModalOpen,
    onClose: handleCloseModal,
    handleSwiftReporting: handleSwiftReporting
  }));
};
export default QuickAccessFilters;